import Presentations from './PresentationsContainer.vue';

export { Presentations };



// WEBPACK FOOTER //
// ./src/modules/home/presentations/index.js